<script>
import { fade } from 'svelte/transition'

import cart from '$src/store/cart.js'
import { currency } from '$src/util/format.js'

$: total = $cart.reduce((total, item) => {
  return total + item.price
}, 0)

function remove(index) {
  cart.update(list => {
    return [...list.slice(0, index), ...list.slice(index + 1)]
  })
}
</script>

<div class="cart">
  {#each $cart as item, index (item)}
    <article out:fade|local>
      <header>
        <h2><a href="{ item.url }">{ item.name }</a></h2>
        <button on:click={ () => remove(index) } class="remove">✘</button>
      </header>

      <img alt="" height="100" width="100" src={ item.image } />

      <p class="price">{ currency(item.price) }</p>
    </article>
  {/each}
</div>

<p class="total">
Total Price:
<span class="price">{ currency(total) }</span>
</p>

<style>
.cart {
  display: grid;
  grid-gap: 1em;
  grid-template-columns: repeat(auto-fit, minmax(calc(100px + 20em), 1fr));
}
article {
  border: 1px solid #EEE;
  display: grid;
  grid-template: "img header" auto "img price" 1fr / calc(100px + 1em) 1fr;
  margin: 1em 0;
  padding: .5em;
}
header {
  align-items: flex-start;
  display: flex;
  grid-area: header;
  justify-content: space-between;
}
h2 {
  font-size: 125%;
  margin: 0;
}
img {
  grid-area: img;
}
.price {
  font-weight: bold;
  grid-area: price;
}
.total {
  font-size: 110%;
}

button.remove {
  background: none;
  color: inherit;
  font-size: 125%;
  line-height: 1.2em;
  padding: 0 0 0 1em;
}
</style>
